module.exports = __webpack_public_path__ + "img/21.d5287ff3.jpg";